import React from "react";
import Hero from "../components/Hero";
import Features from "../components/Features";
import ProductsPreview from "../components/ProductsPreview";
import ContactSection from "../components/ContactSection";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <Features />
      <ProductsPreview />
      <ContactSection />
    </div>
  );
};

export default Home;
